import { useEffect, useState } from "react";
import type { StreamSource } from "@tih/shared";
import { resolveStreamPoster } from "../lib/resolve-stream-poster";

/**
 * `undefined` while probing YouTube thumbnails; otherwise the resolved poster URL
 * (YouTube still when available, else event poster / source.poster).
 */
export function useStreamPoster(
  source: StreamSource,
  fallbackPoster: string | null,
): string | null | undefined {
  const [resolved, setResolved] = useState<string | null | undefined>(() =>
    source.kind === "youtube" ? undefined : (fallbackPoster ?? source.poster ?? null),
  );

  useEffect(() => {
    if (source.kind !== "youtube") {
      setResolved(fallbackPoster ?? source.poster ?? null);
      return;
    }

    let cancelled = false;
    setResolved(undefined);

    void resolveStreamPoster(source, fallbackPoster).then((url) => {
      if (!cancelled) setResolved(url);
    });

    return () => {
      cancelled = true;
    };
  }, [source.kind, source.src, fallbackPoster, source.poster]);

  return resolved;
}
